import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import Abnormal from '@home/components/Abnormal';
import FeatureCard from '../FeatureCard';
import { getNewFeatureItemKey } from '../../utils';

import type { INewFeatureItem } from '@home/types/urlCollection';

import './index.scss';

interface IFeaturesGridProps extends IBaseProps {
  loading: boolean;
  items: INewFeatureItem[];
  onItemClick?: (item: INewFeatureItem) => void;
}

const FeaturesGrid: React.FC<IFeaturesGridProps> = (props) => {
  const { style, className, loading, items, onItemClick } = props;
  const { formatMessage } = useIntl();
  const isEmpty = !loading && items?.length === 0;

  return (
    <div
      style={style}
      className={classnames('dbh-features-grid', className, {
        'dbh-features-grid--loading': loading,
        'dbh-features-grid--empty': isEmpty,
      })}
    >
      <Abnormal
        style={{ height: 90 }}
        isLoading={loading}
        isNoData={isEmpty}
        nodataMsg={formatMessage({
          id: 'dbh_url_collection_new_features_empty',
          defaultMessage: 'Stay tuned for new feature updates.',
        })}
        component={items.map((item) => {
          return <FeatureCard key={getNewFeatureItemKey(item)} item={item} onClick={onItemClick} />;
        })}
      />
    </div>
  );
};

export default FeaturesGrid;
